// #region HTML IDs
export const LOADING_CONTAINER = 'loading-anchor';
export const FILTER_PILL = 'connect-more-filter-pill';
export const TEXT_HEADER = 'connect-more-header';
export const BASKET_BUTTON = 'connect-more-basket-button';
export const PRODUCT_CONTAINER = 'connect-more-products';
export const OVERLAY_CONTAINER = 'connect-more-overlay';
export const OVERLAY_IMAGE_CONTAINER = 'connect-more-overlay-image';
export const OVERLAY_HEADLINE_CONTAINER = 'connect-more-overlay-headline';
export const OVERLAY_PRICE_CONTAINER = 'connect-more-overlay-price';
export const OVERLAY_BUTTON_CONTAINER = 'connect-more-overlay-cta';
export const OVERLAY_TEXT_CONTAINER = 'connect-more-overlay-description';
export const NOTIFICATION_CONTAINER = 'connect-more-notification';
// #endregion

// #region Tracking
export const TRACKING_PAGENAME = 'extras';
// #endregion

// #region Miscellaneous
export const URL_PARAM_DEVICE_ID = 'deviceId';
export const CATEGORY_VALUE_SEPARATOR = '|';
export const CATEGORY_URL_SEPARATOR = ',';
// #endregion
